import { CommonModule } from '@angular/common';
import { Component, inject, input, output } from '@angular/core';
import { LocalizationService } from '@abp/ng.core';
import { ZendraLocalizationPipe } from '@zendra/shared';
import {
  GisInconsistencyGroup,
  GisInconsistencyItem,
} from '../gis-inconsistency-dashboard/gis-inconsistency-dashboard.models';

@Component({
  selector: 'gis-inconsistency-group-card',
  imports: [CommonModule, ZendraLocalizationPipe],
  templateUrl: './gis-inconsistency-group-card.html',
  styleUrl: './gis-inconsistency-group-card.scss',
})
export class GisInconsistencyGroupCard {
  private readonly localizationService = inject(LocalizationService);
  readonly group = input.required<GisInconsistencyGroup>();
  readonly querySelected = output<GisInconsistencyItem>();

  onQuerySelected(item: GisInconsistencyItem): void {
    if (!item.routePath) {
      return;
    }

    this.querySelected.emit(item);
  }

  isZeroCount(item: GisInconsistencyItem): boolean {
    return item.count === 0;
  }

  isDisabled(item: GisInconsistencyItem): boolean {
    return !item.routePath;
  }

  getCountLabel(item: GisInconsistencyItem): string {
    if (this.isDisabled(item)) {
      return '-';
    }

    if (item.countState === 'error') {
      return this.localizationService.instant({
        key: 'Geographic::Entity.GisInconsistencyDashboard.CountUnavailable',
        defaultValue: this.localizationService.currentLang?.startsWith('es') ? 'No disponible' : 'Unavailable',
      });
    }

    if (item.countState === 'loading' || (item.count === null && item.countCase)) {
      return '...';
    }

    return item.count === null ? '-' : String(item.count);
  }
}
